// React Imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// I18n
import { Translate, I18n } from 'react-redux-i18n';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';

// Project Components
import Progress from '../../global/Progress';


/**
 * Component for displaying the Contact Exists Error Page.
 *
 * This component displays an error message and provides options to sign in with a different
 * Adobe ID, or allows the user to contact the helpdesk.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorContactExists />
 * )
 */
class ErrorContactExists extends Component {
  // Signs the user out so they can log in with a different Adobe ID.
  onSignInClick = () => {
    window.adobeIMS.signOut();
  };

  // Grabs the current locale's helpdesk link and opens it in a new window.
  onHelpdeskClick = () => {
    const url = I18n.t('global.footer.help_link');
    window.open(url, '_blank');
  };

  renderOtherAssociatedAccount = () => {
    const { account } = this.props;
    return account;
  }

  // Returns the current signed in user's email to insert into translation string.
  renderImsEmail = () => window.adobeIMS.getUserProfile().email;

  render() {
    return (
      <div>
        <Progress step={0} />
        <div className="page-container">
          <Heading>
            <Translate value="workflow.error_page.problem_header" />
          </Heading>
          <p>
            <Translate value="workflow.error_page.associated_other_account" email={this.renderImsEmail()} program={this.renderOtherAssociatedAccount()} />
          </p>
          <div className="button-container">
            <Button className="btn-signIn" variant="cta" onClick={this.onSignInClick}><Translate value="global.ims.sign_in" /></Button>
            <Button className="btn-helpdesk" onClick={this.onHelpdeskClick}><Translate value="workflow.error_page.contact_helpdesk" /></Button>
          </div>
        </div>
      </div>
    );
  }
}
ErrorContactExists.propTypes = {
  account: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  account: state.company.otherAssociatedAccount,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorContactExists);